import React from "react";
import DateTimeInput from "../fields/DateTimeInput";

// 병원 전 단계 컴포넌트
const PreHospitalSection = ({ formData, setFormData }) => {
  const arrestLocations = [
    "집",
    "직장/학교",
    "거리/도로",
    "공공시설",
    "요양시설",
    "교육시설",
    "스포츠/레크레이션",
    "병원 이송 중",
    "타 병원",
    "기타",
    "미상",
  ];

  const cpcOptions = ["CPC1", "CPC2", "CPC3", "CPC4", "CPC5"];

  return (
    <section className="form-section">
      <h3>1-2. 병원 전 단계</h3>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">
            심정지 발생장소 (arrest_location)
          </label>
          <div className="input_1col">
            {arrestLocations.map((location) => (
              <label key={location} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="arrestLocation"
                  value={location}
                  checked={formData.arrestLocation === location}
                  onChange={(e) =>
                    setFormData({ ...formData, arrestLocation: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{location}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 심정지 발생장소가 "기타"일 때만 나타나는 필드 */}
      {formData.arrestLocation === "기타" && (
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              기타 장소 상세내용 (arrest_location_others)
            </label>
            <div className="input_2col">
              <input
                type="text"
                id="arrest_location_others"
                value={formData.arrestLocationOthers || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    arrestLocationOthers: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
      )}

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">
            심정지 발생 전 CPC (baseline_cpc)
          </label>
          <div className="input_1col">
            {cpcOptions.map((cpc) => (
              <label key={cpc} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="baselineCPC"
                  value={cpc}
                  checked={formData.baselineCPC === cpc}
                  onChange={(e) =>
                    setFormData({ ...formData, baselineCPC: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{cpc}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">심정지 목격 (witness)</label>
          <div className="input_1col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="witness"
                value="목격됨 (witnessed)"
                checked={formData.witness === "목격됨 (witnessed)"}
                onChange={(e) =>
                  setFormData({ ...formData, witness: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">목격됨 (witnessed)</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="witness"
                value="목격되지 않음 (unwitnessed)"
                checked={formData.witness === "목격되지 않음 (unwitnessed)"}
                onChange={(e) =>
                  setFormData({ ...formData, witness: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">목격되지 않음 (unwitnessed)</div>
            </label>
          </div>
        </div>
      </div>

      {/* 심정지 발생 시각 및 마지막 생존 확인 시각 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            심정지 발생 시각 (arrest_time)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="arrest_time"
              value={formData.arrest_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, arrest_time: datetime })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">
            마지막 생존 확인 시각 (LNT_time)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="LNT_time"
              value={formData.LNT_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, LNT_time: datetime })
              }
            />
          </div>
        </div>
      </div>

      {/* 심정지 발견 목격자/발견자 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">
            심정지 발견 목격자/발견자 (witness_by)
          </label>
          <div className="input_1col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="witness_by"
                value="가족"
                checked={formData.witness_by === "가족"}
                onChange={(e) =>
                  setFormData({ ...formData, witness_by: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">가족</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="witness_by"
                value="행인"
                checked={formData.witness_by === "행인"}
                onChange={(e) =>
                  setFormData({ ...formData, witness_by: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">행인</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="witness_by"
                value="구급대원"
                checked={formData.witness_by === "구급대원"}
                onChange={(e) =>
                  setFormData({ ...formData, witness_by: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">근무중인 구급대원</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="witness_by"
                value="의료인(구급대원 제외)"
                checked={formData.witness_by === "의료인(구급대원 제외)"}
                onChange={(e) =>
                  setFormData({ ...formData, witness_by: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">근무중인 의료인</div>
            </label>
            <p className="detail">
              * 근무 중이 아닌 의료인, 구급대원은 가족/행인으로 입력
            </p>
          </div>
        </div>
      </div>

      {/* 즉시 흉부압박 시행여부 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            즉시 흉부압박 시행여부 (Immediate_CPR)
          </label>
          <div className="input_2col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="Immediate_CPR"
                value="예"
                checked={formData.Immediate_CPR === "예"}
                onChange={(e) =>
                  setFormData({ ...formData, Immediate_CPR: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">예</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="Immediate_CPR"
                value="아니오"
                checked={formData.Immediate_CPR === "아니오"}
                onChange={(e) =>
                  setFormData({ ...formData, Immediate_CPR: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">아니오</div>
            </label>
            <p className="detail">
              * 심정지 발견 목격자 종류에 관계 없이 모두 입력
            </p>
          </div>
        </div>
      </div>

      {/* 목격자/발견자 AED 사용 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            목격자/발견자 AED 사용 (Bystander_AED)
          </label>
          <div className="input_2col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="Bystander_AED"
                value="아니오"
                checked={formData.Bystander_AED === "아니오"}
                onChange={(e) =>
                  setFormData({ ...formData, Bystander_AED: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">아니오</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="Bystander_AED"
                value="사용하였으나 shock 권고하지 않음"
                checked={
                  formData.Bystander_AED === "사용하였으나 shock 권고하지 않음"
                }
                onChange={(e) =>
                  setFormData({ ...formData, Bystander_AED: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">사용하였으나 shock 권고하지 않음</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                name="Bystander_AED"
                value="사용하였으며 shock 권고함"
                checked={formData.Bystander_AED === "사용하였으며 shock 권고함"}
                onChange={(e) =>
                  setFormData({ ...formData, Bystander_AED: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">사용하였으며 shock 권고함</div>
            </label>
            <p className="detail">
              * 심정지 발견 목격자가 가족 또는 행인인 경우 입력
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreHospitalSection;
